module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('target-form-upload', {
    ref: "targetPartial",
    attrs: {
      "initialTarget": _vm.target,
      "buttonText": "Upload",
      "errorMessage": _vm.errorMessage,
      "onComplete": _vm.onComplete,
      "originalTarget": _vm.originalTarget
    },
    on: {
      "submit": _vm.handleUpload,
      "activate": _vm.handleActivateTarget
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a32a9d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/CreateUpload.vue
// module id = 1843
// module chunks = 0